import React, { FC } from "react";
import { AvatarDropdownProps } from "./AvatarDropdown.types";
import styles from "./AvatarDropdown.module.scss";
import { Typography } from "../index";
import { FiChevronDown } from "react-icons/fi";

const AvatarDropdown: FC<AvatarDropdownProps> = ({ initials, ...rest }) => {
  return (
    <button
      {...rest}
      className={[styles.AvatarDropdown, rest.className].join("")}
      data-testid="AvatarDropdown"
    >
      <Typography variant={"p"} token={100} weight={"regular"}>
        {initials?.toUpperCase().substring(0, 2)}
      </Typography>
      <span>
        <FiChevronDown />
      </span>
    </button>
  );
};

export default AvatarDropdown;
